import { useSelector } from "react-redux";

const ChangeLanguage = () => {
    const lang = useSelector((state:any) => state?.APIData?.getSetting?.language_data)

    const handleLanguage = () =>{


    }
    
  return (
    <div>
      <h5>Change Language</h5>
      <div className="mt-4">
        <label htmlFor="">Preferred communication language (Email/SMS/Notification) </label>
        <select className="form-control">
            {lang?.map((item:any ,index:any)=>{
                return <option selected={index== 1} key={index} value={item.lan_code}>{item.lan_name}</option>
            })}
        </select>
        <button className="btn-button" onClick={handleLanguage}>Save</button>
      </div>

    </div>
  );
};

export default ChangeLanguage;
